import React, { useState } from "react";
import Image from "next/image";
import DefaultCurrencyFormat from "../calendar/DefaultCurrencyFormat";
import DepositModal from "./DepositModal";

const DepositInfo = ({ villa }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { hasar, Symbol } = villa || {};
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  return (
    <div className="flex items-center bg-[#F6DFCD] md:p-5 p-3 lg:mb-8 mb-4 rounded-[10px] bg-depositBgColor bg-right bg-no-repeat bg-contain">
      <div className="flex items-center gap-2.5">
        <Image
          src="/icons/deposit.svg"
          width={57}
          height={57}
          alt="Deposit"
          className="object-contain"
        />
        <div className="flex flex-col">
          <span className="mb-1 text-sm font-bold leading-4 text-themeBlack">
            Hasar Depozito
          </span>
          <span className="text-themeBlack text-xl font-bold leading-5 mb-1.5">
            <DefaultCurrencyFormat value={hasar} Symbol={Symbol} />
          </span>
          <button
            type="button"
            onClick={toggleModal}
            className="text-xs leading-3 text-left underline cursor-pointer text-themeBlack"
          >
            Bilgi edin
          </button>
        </div>
      </div>
      {isModalOpen && <DepositModal toggleModal={toggleModal} />}
    </div>
  );
};

export default DepositInfo;
